import { DefaultState } from 'store/reducers/types';

export const CREATE_SESSION_SUCCESS = "CREATE_SESSION_SUCCESS";
export const CREATE_SESSION_FAILURE = "CREATE_SESSION_FAILURE";
export const DELETE_SESSION_SUCCESS = "DELETE_SESSION_SUCCESS";
export const RESET_SESSION_STATE = "RESET_SESSION_STATE";

interface CreateSessionSuccess {
	type: typeof CREATE_SESSION_SUCCESS;
	contents: {
		user: {
			userName: string;
			userID: number;
		}
	};
};

interface CreateSessionFailure {
	type: typeof DELETE_SESSION_SUCCESS | typeof CREATE_SESSION_FAILURE;
	message: ""
}

export type SessionState = DefaultState & {
  isAuthenticated: boolean;
  userName: string;
  userId: number;
};

export type SessionActionTypes = CreateSessionSuccess | CreateSessionFailure;